<template>
  <nav class="menu">
    <div class="container">
        <div class="menu-content">
            <router-link to="/">Welcome</router-link>
            <router-link to="/projects">Portfolio</router-link>
        </div>
    </div>
  </nav>
  <router-view/>
</template>

<style lang="scss">
    @import 'styles/vars';
    @import 'styles/general';

    .menu {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9999;
        background: $white;
        border-bottom: 2px solid $primary;
        transition: $transition-options;

        &.scroll {
            border-radius: 0 0 25px 25px;
        }

        &-content {
            display: flex;
            justify-content: center;

            > * {
                padding: 10px 15px;
            }
        }

        + * {
            margin-top: 50px;
        }
    }
</style>
